import {
  MODEL_INFERENCE_ACTIVATION_PATH,
  MODEL_INFERENCE_BASE,
  MODEL_INFERENCE_INTRO_PATH,
} from '@/constants/modelInference';
import {
  type EntitlementSelf,
  isEntitlementActivated,
} from '@/services/inferencePro';
import type { MenuNode } from '@/utils/menu';

/**
 * 已开通即保持二级菜单结构，不随 pathname 切换。
 * 若进入业务页才展开，菜单 DOM 会重挂，顶部选中 class 会闪一下，字重就会 600→400。
 */
export function shouldShowModelInferenceConsoleMenu(
  entitlement?: EntitlementSelf | null,
  _pathname?: string,
) {
  return isEntitlementActivated(entitlement);
}

function isModelInferenceRootMenuItem(item: MenuNode) {
  return item.code === 'ModelInference' || item.path === MODEL_INFERENCE_BASE;
}

/**
 * 未进入控制台时：侧栏仅保留「模型推理」一级入口，不展示二级菜单。
 * 进入控制台后：恢复完整二级菜单，并隐藏开通相关页面。
 */
export function filterModelInferenceMenu(
  menuData: MenuNode[],
  showConsoleMenu: boolean,
): MenuNode[] {
  return menuData.map((item) => {
    if (!isModelInferenceRootMenuItem(item)) {
      return item;
    }

    if (!showConsoleMenu) {
      // 使用模块根路径，便于 intro / activation 等子路径命中侧栏选中态
      return {
        ...item,
        path: MODEL_INFERENCE_BASE,
        routes: undefined,
      };
    }

    const childRoutes = item.routes?.filter(
      (child) =>
        child.path !== MODEL_INFERENCE_INTRO_PATH &&
        child.path !== MODEL_INFERENCE_ACTIVATION_PATH,
    );

    return {
      ...item,
      routes: childRoutes?.length ? childRoutes : item.routes,
    };
  });
}
